export default __webpack_public_path__ + "static/media/assessment-pass-shaded.5a4461d2.png";